<template>
    
</template>
<script>
export default {
    async created() {
        window.location.replace("/profile");
    }
    }
</script>